import {
  Plus,
  ListOrdered,
  ClipboardList,
  Settings,
  Headphones,
  FileText,
  LucideIcon,
  FileQuestion,
  Heart,
} from "lucide-react";
import { dashboardLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

export interface Message {
  sender: string;
  content: string;
  time: string;
}

export interface NavigationItem {
  title: string;
  subtitle: string;
  path: string;
  icon: LucideIcon;
  color: string;
  width: string;
  animation: string;
  messages?: Message[];
  disabled?: boolean;
  disabledTooltip?: string;
}

export const getAdminNavigationItems = (options?: {
  canManageSupport?: boolean;
}): NavigationItem[] => {
  const dashboardLabels_i18n = dashboardLabels(getLanguage());
  const canManageSupport = options?.canManageSupport !== false;

  return [
    {
      title: dashboardLabels_i18n.support.title,
      subtitle: dashboardLabels_i18n.support.adminSubtitle,
      path: "/admin/support",
      icon: Headphones,
      color: "from-[#FF8A48] to-[#FFA347]",
      width: "col-span-2",
      animation: "",
      disabled: !canManageSupport,
      disabledTooltip: "Kräver behörighet Hantera support",
    },
    {
      title: dashboardLabels_i18n.economy.title,
      subtitle: dashboardLabels_i18n.economy.subtitle,
      path: "/admin/economy",
      icon: ClipboardList,
      color: "from-[#4CD964] to-[#4CAF50]",
      // Mobile: with postAd in cols-7 (4+3); desktop row uses col-span-2 of 11
      width: "col-span-3 md:col-span-2",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.test.title,
      subtitle: dashboardLabels_i18n.test.adminSubtitle,
      path: "/admin/car-test",
      icon: FileText,
      color: "from-[#E6B800] to-[#E6B800]",
      width: "col-span-4",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.leadbox.title,
      subtitle: dashboardLabels_i18n.leadbox.subtitle,
      path: "/admin/leadbox",
      icon: FileQuestion,
      color: "from-[#E92121] to-[#F06C6C]",
      // Mobile: settings(3)+leadbox(2)=5; desktop: 3/11
      width: "col-span-2 md:col-span-3",
      animation: "",
    },
  ];
};

export const getNavigationItems = (): NavigationItem[] => {
  const dashboardLabels_i18n = dashboardLabels(getLanguage());

  return [
    {
      title: dashboardLabels_i18n.postAd.title,
      subtitle: dashboardLabels_i18n.postAd.subtitle,
      path: "/list-or-value-car",
      icon: Plus,
      color: "from-[#FF7AA4] to-[#F77FC5]",
      width: "col-span-4",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.listings.title,
      subtitle: dashboardLabels_i18n.listings.subtitle,
      path: "/auctions",
      icon: ListOrdered,
      color: "from-[#3B82F6] to-[#2563EB]",
      width: "col-span-3",
      animation: "",
    },
    {
      // Merged "Mina annonser | Ordrar" hub (tabs on the page)
      title: dashboardLabels_i18n.myListingsOrders.title,
      subtitle: dashboardLabels_i18n.myListingsOrders.subtitle,
      path: "/my-auctions",
      icon: ClipboardList,
      color: "from-[#4CD964] to-[#4CAF50]",
      // Mobile: with postAd in cols-7 (4+3) so card stays readable; desktop: 3/11
      width: "col-span-3",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.support.title,
      subtitle: dashboardLabels_i18n.support.subtitle,
      path: "/support",
      icon: Headphones,
      color: "from-[#FF8A48] to-[#FFA347]",
      width: "col-span-2",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.settings.title,
      subtitle: dashboardLabels_i18n.settings.subtitle,
      path: "/settings",
      icon: Settings,
      color: "from-[#6B78E5] to-[#5A4CB0]",
      // Mobile: previous structure settings(3)+favorites(2); desktop unchanged
      width: "col-span-3",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.test.title,
      subtitle: dashboardLabels_i18n.test.subtitle,
      path: "/car-test",
      icon: FileText,
      color: "from-[#E6B800] to-[#E6B800]",
      width: "col-span-4",
      animation: "",
    },
    {
      title: dashboardLabels_i18n.favorites.title,
      subtitle: dashboardLabels_i18n.favorites.subtitle,
      path: "/favorites",
      icon: Heart,
      color: "from-[#E92121] to-[#F06C6C]",
      width: "col-span-2",
      animation: "",
    },
  ];
};
